import axios from 'axios';
import account from '@/api/v1/account';

// URL and endpoint constants
// Codeweb
const INDEX_URL = '/childweb'; // GET, POST
const PDF_URL = '/childweb/pdf'; // GET, POST
const PINBOARD_ID = account.user.pinboard;

export default {
  // GET children belonging to a pinboard
  index(succ) {
    axios.get(INDEX_URL, { params: { pinboardid: PINBOARD_ID } }).then((response) => {
      succ(response.data);
    });
  },
  new(data) {
    // eslint-disable-next-line
    data.pinboardid = account.user.pinboard;
    return axios.post(INDEX_URL, data);
  },
  edit(data) {
    // eslint-disable-next-line
    data.pinboardid = account.user.pinboard;
    return axios.put(INDEX_URL, data);
  },
  delete(id) {
    return axios.delete(`${INDEX_URL}/${id}`);
  },
  exportPdf(ids, succ) {
    axios.get(PDF_URL, {
      params: { child: ids },
      headers: { 'Content-Type': 'application/pdf' },
      responseType: 'blob', // can return arraybuffer or blob
    }).then((response) => {
      succ(response);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/childweb.js